import styled, { css } from 'styled-components';

export const ScheduleMessageCardContainer = styled.div<{ isError?: boolean }>`
  padding: var(--spacement-default);
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--spacement-medium);
  background-color: #ffffff;
  border-radius: var(--radius-small);
  border: 1px solid var(--neutral- 2);

  ${props => props.isError && css`
    background-color: #FFFCDF;
    border-color: #FFDD6D;
  `}

  @media screen and (max-width: 828px) {
    max-width: 90%;
    margin-inline: auto;
    margin-bottom: var(--spacement-large);
  }
`
